module.exports = {"id":"190941","name":"Lukáš Hrádecký","rating":"83","photo":"./data/images/photos/4/190941.png","club":{"name":"Eint. Francfort","logo":"./data/images/clubs/Eint.Francfort.png"},"positions":["G"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LukasHradecky0.json
// module id = 2635
// module chunks = 0